module.exports = __webpack_public_path__ + "img/5@2x.91c08841.png";